window.addEventListener("load", () =>
    globalThis.ret.initContentTooltips(".js-header-notifications-tooltip-init"),
);
